// extracted by mini-css-extract-plugin
export default {"modalCancel":"ModalButtons-module__modalCancel--hTYdw"};